import { useEffect } from 'react'

import { useQuery } from 'react-query'

import { getCardPinUseCase } from '@webapp/modules/spending-cards/business-logic/use-cases/GetCardPin'
import { cardQueryConfig } from '@webapp/modules/spending-cards/query-configs/card'

type UseQueryCardPinReturn = {
  iframeUrl: string | undefined
  isFetching: boolean
  refetch: () => void
  clearIframeUrl: () => void
}

export const useQueryCardPin = ({
  externalId,
  scaToken,
  onVerificationRequired = () => undefined,
  customCss = {},
  enabled = true,
  onError = () => undefined,
}: {
  externalId: string
  scaToken?: string
  onVerificationRequired?: (scaSessionCode: string) => void
  customCss?: Record<string, Record<string, string>>
  enabled?: boolean
  onError?: (error: Error) => void
}): UseQueryCardPinReturn => {
  const { data, isFetching, remove, refetch } = useQuery({
    queryKey: cardQueryConfig.cardPin(externalId, scaToken).queryKey,
    queryFn: () => getCardPinUseCase({ externalId, customCss, scaToken }),
    enabled,
    onError,
  })

  const scaSessionCode =
    !!data?.data && 'scaSessionCode' in data.data
      ? data.data.scaSessionCode
      : undefined
  useEffect(() => {
    if (scaSessionCode) {
      onVerificationRequired(scaSessionCode)
    }
  }, [scaSessionCode])

  useEffect(() => {
    return () => remove()
  }, [remove])

  return {
    iframeUrl: data?.data?.url,
    refetch,
    isFetching,
    clearIframeUrl: () => {
      remove()
    },
  }
}
